import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { H3, Image, LI, P, UL } from "../../../../../../AbstractElements";
import { dynamicImage } from "../../../../../../Utils";
import { getAPIURL, getUserID } from "../../../../../../services/helper";
import http from "../../../../../../services/http";
import { toast } from "react-toastify";
import { Button } from "reactstrap";
import {
  changeChat,
  createNewChatAsync,
  setLoading,
  UpdateFriends,
  UpdateRequests,
} from "../../../../../../ReduxToolkit/Reducers/ChatReducer";

export default function Requests({ changeToChat }) {
  const { chats, currentUser, members, pending_friends, store_chat_requests } =
    useSelector((state) => state.chat);
  const [FriendRequests, setFriendRequests] = useState([]);
  const [ChatRequests, setChatRequests] = useState([]);
  const current_user_id = getUserID();
  const api_url = getAPIURL();
  const dispatch = useDispatch();

  useEffect(() => {
    // Set friend requests
    const pendingRequests = members.filter((member) =>
      pending_friends.includes(member.id)
    );
    setFriendRequests(pendingRequests);

    // Set chat requests
    const chatRequests = members.filter((member) =>
      store_chat_requests.includes(member.id)
    );
    setChatRequests(chatRequests);
  }, [members, pending_friends, store_chat_requests]);

  const handleAcceptFriendRequest = async (id) => {
    const data = {
      user_id: current_user_id,
      friends_id: id,
    };
    try {
      dispatch(setLoading(true));
      const resp = await http.post(`${api_url}/friends/requests/accept`, data);
      if (resp.data.success) {
        toast.success("Friend request accepted successfully");
        const { friends_list, pending_requests } = resp.data.data;
        dispatch(UpdateFriends(friends_list));
        dispatch(UpdateRequests(pending_requests));
      } else {
        toast.error(resp.data.message);
      }
      dispatch(setLoading(false));
    } catch (error) {
      toast.error("Error accepting friend request");
      dispatch(setLoading(false));
    }
  };

  const handleAcceptChatRequest = async (selectedUserId) => {
    const currentUserId = currentUser.id;
    const currentChat = chats.find(
      (x) =>
        x.users.includes(currentUser.id ?? 0) &&
        x.users.includes(selectedUserId)
    );
    if (currentChat) {
      dispatch(changeChat(selectedUserId));
    } else {
      dispatch(createNewChatAsync({ currentUserId, selectedUserId, chats }));
    }
    changeToChat();
  };

  return (
    <div className="contact-wrapper">
      {/* Friends Requests Section */}
      {FriendRequests.length > 0 ? (
        <>
          <H3>Friend Requests</H3>
          <UL className="border-0 simple-list">
            {FriendRequests.map((item) => (
              <LI className="common-space" key={item.id}>
                <div className="chat-time">
                  <Image
                    className="img-fluid rounded-circle"
                    src={
                      item?.image ? item?.image : dynamicImage("avtar/3.jpg")
                    }
                    alt="user"
                  />
                  <div>
                    <span>{item?.name}</span>
                    <P>{item?.store_name}</P>
                  </div>
                </div>
                <Button
                  className="ml-auto"
                  color="primary"
                  size="sm"
                  onClick={() => handleAcceptFriendRequest(item.id)}
                >
                  Accept
                </Button>
              </LI>
            ))}
          </UL>
        </>
      ) : (
        <div className="text-center">No Friend Requests</div>
      )}

      {/* Chat Requests Section */}
      {ChatRequests.length > 0 ? (
        <>
          <H3 className="mt-4">Chat Requests</H3>
          <UL className="border-0 simple-list">
            {ChatRequests.map((item) => (
              <LI className="common-space" key={item.id}>
                <div className="chat-time">
                  <Image
                    className="img-fluid rounded-circle"
                    src={
                      item?.image ? item?.image : dynamicImage("avtar/3.jpg")
                    }
                    alt="user"
                  />
                  <div>
                    <span>{item?.name}</span>
                    <P>{item?.store_name}</P>
                  </div>
                </div>
                <Button
                  className="ml-auto"
                  color="primary"
                  size="sm"
                  onClick={() => handleAcceptChatRequest(item.id)}
                >
                  Start Chat
                </Button>
              </LI>
            ))}
          </UL>
        </>
      ) : (
        <div className="text-center mt-4">No Chat Requests</div>
      )}
    </div>
  );
}
